// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as DeccoUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";
import * as ResponseHandler$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/ResponseHandler.bs.js";

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var error = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict._0, "error"), null));
  if (error.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              error: error._0
            }
          };
  }
  var e = error._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".error" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

var Decode = {
  t_decode: t_decode
};

function decodeInvalidCredentials(data) {
  return /* DefaultError */{
          _0: {
            title: {
              TAG: /* UnprocessedEntity */1,
              _0: data.error
            },
            message: Belt_Option.getWithDefault(data.error, "Something went wrong!")
          }
        };
}

function execute(response) {
  if (typeof response === "number" || response.TAG !== /* UnprocessedEntity */2) {
    return ResponseHandler$Catalyst.DefaultErrorConverter.execute(response);
  } else {
    return decodeInvalidCredentials(DeccoUtils$Catalyst.resolveResult(t_decode(response._0), "PlaceOrderErrorConverter.res"));
  }
}

export {
  Decode ,
  decodeInvalidCredentials ,
  execute ,
  
}
/* DeccoUtils-Catalyst Not a pure module */
